import * as types from './actionTypes';
import initialState from '../../../../../reducers/initialState';
import * as eventTypes from './eventTypes';
import { emptyObject } from 'constants/emptyConst';

const shareholdersReducer = (state = initialState.currentOffer.clientShareholdersData, action) => {
  switch (action.type) {
    case types.LOAD_SHAREHOLDERS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_SHAREHOLDERS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_SHAREHOLDERS_SUMMARY_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = {
        ...state[key],
        summaryLoaded: true,
        summary: action.summary
      };
      return result;
    }

    case eventTypes.SHAREHOLDERS_INVALIDATED: {
      let key = action.event.eventBody.partnerId;
      let result = { ...state };
      result[key] = {
        ...result[key],
        loading: false,
        loaded: false,
        summaryLoaded: false
      };
      return result;
    }

    case eventTypes.SHAREHOLDERS_UPDATED: {
      let key = action.event.eventBody.partnerId;
      let result = { ...state };
      result[key] = {
        ...result[key],
        summaryLoaded: false
      };
      return result;
    }

    case eventTypes.ALL_SHAREHOLDERS_INVALIDATED: {
      return emptyObject;
    }

    case types.LOAD_SHAREHOLDERS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_SHAREHOLDERS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: true };
      return result;
    }

    default:
      return state;
  }
};

export default shareholdersReducer;
